import React from 'react';
import { Path } from '../../../common/consts/Path';
import { appRender } from '../../../common/helpers/appRender/appRender';
import { AppPageRoute, BaseAppPage } from '../BaseAppPage/BaseAppPage';
import { LoginWrapper } from '../LoginWrapper/LoginWrapper';

const LoginPage = React.lazy(() => import('../../components/pages/LoginPage/LoginPage'));
const GenericLoginPage = React.lazy(() => import('../../components/pages/GenericLoginPage/GenericLoginPage'));
const ForgotLoginPage = React.lazy(() => import('../../components/pages/ForgotLoginPage/ForgotLoginPage'));
const ResetPage = React.lazy(() => import('../../components/pages/ResetLoginPage/ResetLoginPage'));
const MagicLinkLoginPage = React.lazy(() => import('../../components/pages/MagicLinkLoginPage/MagicLinkLoginPage'));
const RequestMagicLinkPage = React.lazy(() => import('../../components/pages/RequestMagicLinkPage/RequestMagicLinkPage'));

const routes: AppPageRoute[] = [
	{ path: Path.LOGIN, Component: LoginPage },
	{ path: Path.GENERIC_LOGIN, Component: GenericLoginPage },
	{ path: Path.FORGOT, Component: ForgotLoginPage },
	{ path: Path.RESET, Component: ResetPage },
	{ path: Path.RESET_ACTIVATION, Component: ResetPage },
	{ path: Path.MAGIC_LINK_LOGIN, Component: MagicLinkLoginPage },
	{ path: Path.REQUEST_MAGIC_LINK, Component: RequestMagicLinkPage },
];

const LoginApp = () => {
	return (
		<LoginWrapper>
			<BaseAppPage routes={routes} />
		</LoginWrapper>
	);
};

function main() {
	return appRender(() => <LoginApp />);
}

main();
